import React from 'react';
import { useSelector } from 'react-redux';
import PackageCard from '../Components/Cards/PackagesCard';

const SearchResults = ({ searchTerm }) => {
    const { searchResults, loading: searchLoading, error: searchError } = useSelector((state) => state.package);

    const placeholderPackage = {
        id: 'placeholder',
        days: '',
        rating: 0,
        reviews: 0,
        title: '',
        images: ['https://via.placeholder.com/300x200?text=Loading'],
        itinerary: '',
        price: 0,
        originalPrice: 0,
        savings: 0,
    };

    const displayPackages = searchLoading
        ? Array(3).fill(placeholderPackage).map((pkg, index) => ({ ...pkg, id: `placeholder-${index}` }))
        : searchResults;

    return (
        <div className="mb-8">
            <div className="flex justify-between items-center mb-4 relative">
                <h2 className="text-2xl font-semibold text-custom-blue mx-auto">
                    Search Results for "{searchTerm || 'All Tours'}"
                </h2>
            </div>
            {searchError && (
                <div className="text-center text-red-600 mb-4">{searchError}</div>
            )}
            {!searchLoading && !searchError && searchResults.length === 0 && (
                <div className="text-center text-gray-600">
                    No tours found for "{searchTerm}".
                </div>
            )}
            <div
                className="flex space-x-1 overflow-x-auto scrollbar-hide"
                style={{ filter: searchLoading ? 'blur(4px)' : 'none', transition: 'filter 0.3s ease' }}
            >
                {displayPackages.map((pkg) => (
                    <PackageCard key={pkg._id || pkg.id} pkg={pkg} />
                ))}
            </div>
        </div>
    );
};

export default SearchResults;